export * from '@primeuix/themes/lara/tag';
export { default } from '@primeuix/themes/lara/tag';
